import { isNil, isEmpty, flattenDeep } from 'lodash'

const helpers = {
    getNode: (list, nodeId) => {
        let res = {}
        for (const node of list) {
            if (!isEmpty(res)) {
                break
            }
            if ((!isNil(node.id) && node.id === nodeId) || (isNil(node.id) && node.key === nodeId)) {
                res = node
            } else if (node.id !== nodeId && node.key !== nodeId) {
                if (!isEmpty(node.children)) {
                    res = helpers.getNode(node.children, nodeId)
                }
            }
        }
        return res
    },

    getNodeChildren: list => {
        const childrenList = []
        for (const node of list) {
            childrenList.push(node)
            if (!isEmpty(node.children)) {
                childrenList.push(helpers.getNodeChildren(node.children))
            }
        }
        return flattenDeep(childrenList)
    },

    parseItems: items => {
        const _items = []
        for (const item of items) {
            const _item = {
                ...item,
                category: item.key.split('_').pop(),
                //display_order: toNumber(item.display_order),
                children: isNil(item.children) ? [] : helpers.parseItems(item.children)
            }
            // adding an history for smart segments for proper UI manipulation
            if (_item.hasOwnProperty('smart_segments')) {
                const smartSegmentsList = []
                for (const smartSemgments of _item.smart_segments) {
                    const smartSegment = smartSemgments
                    smartSegment.initialBootstrapStatus = smartSemgments.bootstrap_status
                    smartSegmentsList.push(smartSegment)
                }
            }
            if (_item.hasOwnProperty('rule')) {
                _item.historyRule = { ..._item.rule }
            }

            delete _item.display_order
            _items.push(_item)
        }
        return _items
    },

    formatSharedTaxonomies: items => {
        if (isEmpty(items)) return []
        return items.filter(item => item.status === 'active').map(item => item.product_account_id)
    }
}

export default helpers
